import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import PaletteRoundedIcon from '@mui/icons-material/PaletteRounded';
import CheckRoundedIcon   from '@mui/icons-material/CheckRounded';
import { ThemeMenu } from '../../v4/components/ThemePicker';

/* v3 has no CSS variables, so the shared menu gets fixed v3 colors. */
function renderItem(v, { active, mode }) {
  const t = v.tokens[mode];
  return (
    <>
      <Box sx={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0, background: t.bg, border: `4px solid ${t.cyan}`, boxShadow: '0 0 0 1px rgba(255,255,255,0.15)' }} />
      <Typography sx={{ flex: 1, ml: 1.5, fontSize: '0.88rem', fontWeight: active ? 700 : 500, color: 'rgba(255,255,255,0.9)' }}>{v.label}</Typography>
      <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.35)', ml: 2 }}>{v.id}</Typography>
      <CheckRoundedIcon sx={{ fontSize: 16, ml: 1, color: '#76c442', visibility: active ? 'visible' : 'hidden' }} />
    </>
  );
}

export default function ThemePicker({ sx = {} }) {
  const [anchorEl, setAnchor] = useState(null);

  return (
    <>
      <Tooltip title="Theme wählen">
        <IconButton
          size="small"
          onClick={e => setAnchor(e.currentTarget)}
          aria-label="Theme wählen"
          aria-haspopup="menu"
          sx={{
            color: '#76c442',
            border: '1px solid rgba(118,196,66,0.15)',
            borderRadius: '10px',
            '&:hover': { background: 'rgba(118,196,66,0.08)' },
            ...sx,
          }}
        >
          <PaletteRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <ThemeMenu
        anchorEl={anchorEl} onClose={() => setAnchor(null)} current="v3"
        renderItem={renderItem}
        paperSx={{ borderRadius: '14px', background: 'rgba(8,20,9,0.97)', border: '1px solid rgba(118,196,66,0.15)', backdropFilter: 'blur(20px)' }}
        itemSx={{ mx: 0.75, borderRadius: '10px', '&.Mui-selected': { background: 'rgba(118,196,66,0.12)' } }}
      />
    </>
  );
}
